import { AllotmentService } from './../../../services/allotment.service';
import { IPaged } from './../../../../_models/common/IPaged';
import { IServiceBook } from './../../../../_models/profile-sections/IServiceBook';
import { CommonService } from './../../../../shared/services/common.service';
import { IKeyValuePair } from './../../../../_models/common/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingService } from 'src/app/shared/services/setting.service';
import { ISetting } from 'src/app/_models/cms/ISetting';

@Component({
  selector: 'app-allotment-list',
  templateUrl: './allotment-list.component.html',
  styleUrls: ['./allotment-list.component.css']
})
export class AllotmentListComponent implements OnInit {
  loading: boolean = true;
  private readonly PAGE_SIZE = 10;

  queryResult: IPaged = {
    pageNumber: 0,
    items: [],
    totalRows: 0,
    pageSize: this.PAGE_SIZE
  };

  query: any = {
    page: 1,
    pageSize: this.PAGE_SIZE,
    sort: 'MeritNo',
    sortDir: 'Descending',
    designationId: '',
    stateId: '',
    districtId: '',
    schoolId: '',
    shalaId: '',
    isDisplaced: '',
    isTotalTrasfer: '',
    financialYearId: ''
  };

  columns = [
    { title: 'MeritNo', key: 'MeritNo', isSortable: false },
    { title: 'Name', key: 'MeritNo', isSortable: false },
    { title: 'Designation', key: 'DesignationId', isSortable: false },
    { title: 'Category', key: 'TransferCategoryId', isSortable: false },
    { title: 'From', key: 'MeritNo', isSortable: false },
    { title: 'Total Day', key: 'TotalDay', isSortable: false },
    { title: 'To School', key: 'SchoolId', isSortable: false },
    { title: 'TenureComplete', key: 'SchoolId', isSortable: false },
    { title: 'TenureHardComplete', key: 'SchoolId', isSortable: false },
    { title: 'Displaced', key: 'SchoolId', isSortable: false },
    { title: 'Probation', key: 'SchoolId', isSortable: false },
    { title: 'SpecReqDriveCompleted', key: 'SchoolId', isSortable: false },
    { title: 'RetirementNear', key: 'SchoolId', isSortable: false },
    { title: 'IsTransfer', key: 'SchoolId', isSortable: false },
    { title: 'SingleWomen', key: 'SchoolId', isSortable: false },
    { title: 'SpouseIn', key: 'SchoolId', isSortable: false },
    { title: 'SpouseOut', key: 'SchoolId', isSortable: false },
    { title: 'Cumulative', key: 'SchoolId', isSortable: false },
    { title: 'AdminGround', key: 'SchoolId', isSortable: false },
    { title: 'HardServedForPlain', key: 'SchoolId', isSortable: false },
    { title: 'HardServedForPlainDays', key: 'SchoolId', isSortable: false },
    { title: 'IsRTTenureComplete', key: 'SchoolId', isSortable: false },
    { title: 'IsRTDisplaced', key: 'SchoolId', isSortable: false },
    { title: 'IsRTNative', key: 'SchoolId', isSortable: false },
    { title: 'IsPreviousStationCalc', key: 'SchoolId', isSortable: false },
    { title: 'IsWillingHard', key: 'SchoolId', isSortable: false },
    { title: 'IsDisplaceEligibility', key: 'SchoolId', isSortable: false },
    {},
  ];

  regions: IKeyValuePair[];
  states: IKeyValuePair[];
  districts: IKeyValuePair[];
  schools: IKeyValuePair[];
  designations: IKeyValuePair[];
  financialYears: IKeyValuePair[];
  financialYearId;
  setting: ISetting;
  constructor(private router: Router,
    private route: ActivatedRoute,
    private service: AllotmentService,
    private settingService: SettingService,
    private commonService: CommonService) {
      this.financialYearId = this.route.snapshot.paramMap.get('financialYearId');
  }

  ngOnInit() {
    this.settingService.getSetting().then(data => {
      this.setting = data;
      this.query.financialYearId = this.setting?.financialYearId;
    });
    this.bindDropDown(); 
    this.route.queryParams
      .subscribe(params => {
        this.query.page = isNaN(params.page) ? 1 : params.page;
        this.query.sort = params.sort;
        this.query.sortDir = params.sortDir;
        this.query.designationId = params.designationId ? params.designationId : '';
        this.query.regionId = params.regionId ? params.regionId : '';
        this.query.stateId = params.stateId ? params.stateId : '';
        this.query.districtId = params.districtId ? params.districtId : '';
        this.query.schoolId = params.schoolId ? params.schoolId : '';
        this.query.shalaId = params.shalaId ? params.shalaId : '';
        this.query.isDisplaced = params.isDisplaced ? params.isDisplaced : '';
        this.query.isTotalTrasfer = params.isTotalTrasfer ? params.isTotalTrasfer : '';
        this.query.financialYearId = params.financialYearId ? params.financialYearId : this.setting?.financialYearId;
        this.route.queryParams.subscribe(params => { 
          // Get the current URL with the updated query parameters
          const relativeUrl = this.router.url;
          // Store the current URL in localStorage whenever the query params change
          localStorage.setItem('relativeUrl', relativeUrl);
        });
        this.populateEmployeeMerits();
        this.bindCascadeDropdown();
      });

     // if(this.setting?.financialYearId == this.query.financialYearId){
       
      //}
  }
 
  private populateEmployeeMerits() {
    this.loading = true;
    this.service.getAll(this.query)
      .subscribe((response: IPaged) => {
        if (response) {
          this.queryResult = response;
        }
      }, (err) => console.log(err),
        () => this.loading = false);          
  }


  bindDropDown() {
    this.commonService.getRegions().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.regions = response;
      }
    });
    this.commonService.getDesignations().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.designations = response;
      }
    });
    this.commonService.getFinancialYears().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.financialYears = response;
      } 
    });
  }

  bindCascadeDropdown() {
    if (this.query.regionId) {
      this.getStates(this.query.regionId);
    }
    if (this.query.stateId) {
      this.getDistricts(this.query.stateId);
    }
    if (this.query.districtId) {
      this.getSchools(this.query.districtId);
    }
  }

  getStates(regionId: string) {
    this.commonService.getStates(regionId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.states = response;
      }
    });
  }

  getDistricts(stateId: number) {
    this.commonService.getDistricts(stateId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.districts = response;
      }
    });
  }

  getSchools(districtId: number) {
    this.commonService.getSchools(districtId, 1).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.schools = response;
      }
    });
  }

  sortBy(columnName) {
    this.query.page = 1;
    if (this.query.sort === columnName) {
      this.query.sortDir = (this.query.sortDir == "Descending" ? "Ascending" : "Descending");
    } else {
      this.query.sort = columnName;
      this.query.sortDir = "Descending";
    }

    this.router.navigate(['/management/allotment'], {
      queryParams: this.query
    });
  }

  filter() {
    this.query.page = 1;
    console.log('Query before filtering:', this.query);
    this.router.navigate(['/management/allotment'], {
      queryParams: this.query
    });
  }
  

  getServiceBook(v: IServiceBook[]) {
    return v ? v.find(x => x.isPresent == true) : null;
  }

}
